import React from 'react';
import Footer from '../../../layout/Footer/Footer';
import useDarkMode from '../../../hooks/useDarkMode';
import classNames from 'classnames';

const DefaultFooter = () => {
	const { darkModeStatus } = useDarkMode();
	const getYear = () => {
		return new Date().getFullYear();
	};
	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>
						<span className='fw-light'>
							© {getYear()}{' '}
							<a
								href='https://arktechltd.com'
								target={'_blank'}
								style={{ textDecoration: 'none' }}>
								{process.env.REACT_APP_COMPANY_NAME}
							</a>
						</span>
					</div>
					<div className='col-auto'>
						<a
							style={{ cursor: 'pointer' }}
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='fw-bold'>{process.env.REACT_APP_COMPANY_NAME}</small>
						</a>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
